import axios from 'axios';
import env from '../../env';
import { authProvider, authenticationParameters } from '../provider/authProvider';

const ID_TOKEN = "msal.idtoken";

let apiMatriz = axios.create({
    baseURL: `${env.BASE_URL_MATRIZ}/api`,
    headers: {
        Authorization: `Bearer `
    }
});

apiMatriz.interceptors.request.use(config => {
    if (window !== undefined) {
        const bearer = localStorage.getItem(ID_TOKEN);
        config.headers['Authorization'] = `Bearer ${bearer}`;
    }
    return config;
});


apiMatriz.interceptors.response.use(response => response, async err => {
    if (err.response && err.response.status === 401) {
        await authProvider.acquireTokenSilent(authenticationParameters);
    }
    return Promise.reject(err);
});


export default apiMatriz;
